"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _common = require("@insided/shared/utils/common");

var _PanelItems = require("../PanelItems");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _Message = require("../../../ui-components/Message");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _IntegrationByZapier = _interopRequireDefault(require("./IntegrationByZapier"));

var _SyncContentStatus = _interopRequireDefault(require("../SyncContentStatus"));

var _constants = require("@insided/shared/constants");

var IntegrationTab = function IntegrationTab(_ref) {
  var activePanel = _ref.activePanel,
      isInstalled = _ref.isInstalled,
      isFederatedSearchActive = _ref.isFederatedSearchActive,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      onSettingChanged = _ref.onSettingChanged,
      onConversationCreationSettingChanged = _ref.onConversationCreationSettingChanged,
      onResetConversationCreationSetting = _ref.onResetConversationCreationSetting,
      onSaveConversationCreationSetting = _ref.onSaveConversationCreationSetting,
      showActionButtons = _ref.showActionButtons,
      hasUnsavedChanges = _ref.hasUnsavedChanges,
      showUnsavedChangesModal = _ref.showUnsavedChangesModal,
      isConversationCreationSettingEnabled = _ref.isConversationCreationSettingEnabled,
      displayUnsavedChangedModal = _ref.displayUnsavedChangedModal,
      _closeModal = _ref.closeModal,
      _resetChanges = _ref.resetChanges,
      storedState = _ref.storedState,
      onClickPanelCallback = _ref.onClickPanelCallback,
      isSavingConversationCreationSetting = _ref.isSavingConversationCreationSetting,
      isSavingFederatedSearchSetting = _ref.isSavingFederatedSearchSetting;
  var FederatedSearchIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Intercom federated search',
    toggleLabel: 'Enable Intercom federated search',
    isInstalled: isInstalled,
    isSettingEnabled: isFederatedSearchActive,
    storedIsSettingEnabled: storedState.isFederatedSearchActive,
    imageFromName: 'intercom-s',
    imageToName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    description: "Empower end users to search for Intercom content through ".concat(_constants.PLATFORM_BRAND_NAME, "."),
    onSave: onSave,
    onCancel: onCancel,
    onSettingChanged: onSettingChanged,
    showActionButtons: showActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanel: onClickPanelCallback,
    customClass: 'qa-intercom-federated-search',
    communityArticleLink: 'https://communities.gainsight.com/integrations-54/how-to-set-up-intercom-federated-search-22289',
    additionalHelpText: (0, _preact.h)(AdditionalHelpText, null),
    integrationStatus: (0, _preact.h)(_SyncContentStatus.default, {
      isInstalled: isInstalled,
      storedIsSettingEnabled: storedState.isFederatedSearchActive,
      statusUrl: "/integration/intercom/status",
      syncUrl: "/integration/intercom/sync"
    }),
    isLoading: isSavingFederatedSearchSetting
  });
  var ConversationCreationIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Create Intercom conversations from community posts',
    toggleLabel: 'Enable moderators to create Intercom conversations.',
    isInstalled: isInstalled,
    isSettingEnabled: isConversationCreationSettingEnabled,
    storedIsSettingEnabled: storedState.isConversationCreationEnabled,
    imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    imageToName: 'intercom-s',
    description: 'Create an Intercom conversation from user-generated content (questions, conversations, ideas, replies) via Control.',
    onSave: onSaveConversationCreationSetting,
    onCancel: onResetConversationCreationSetting,
    onSettingChanged: onConversationCreationSettingChanged,
    showActionButtons: showActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanel: onClickPanelCallback,
    customClass: 'qa-intercom-conversation-creation',
    communityArticleLink: 'https://communities.gainsight.com/integrations-54/how-to-create-intercom-conversation-from-community-post-22060',
    additionalHelpText: (0, _preact.h)("span", null, "Open a topic from the", ' ', (0, _preact.h)("a", {
      className: "overview-page-link",
      rel: "noreferrer",
      target: "_blank",
      href: (0, _absoluteUrlRuntime.resolveUrl)("/overview")
    }, "content overview"), ' ', "and click the Intercom logo next to any user-generated content to create a conversation."),
    isLoading: isSavingConversationCreationSetting
  });
  var panels = [];

  if (_common.common.isModuleActive('intercomFederatedSearch')) {
    panels.push(FederatedSearchIntegrationPanel);
  }

  if (_common.common.isModuleActive('intercomCreateConversations')) {
    panels.push(ConversationCreationIntegrationPanel);
  }

  return (0, _preact.h)("div", {
    className: "integration__tab intercom-integration__tab"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: activePanel,
    panels: panels,
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  }), (0, _preact.h)(_IntegrationByZapier.default, {
    isInstalled: isInstalled
  }), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal();
    },
    resetChanges: function resetChanges() {
      return _resetChanges();
    }
  }));
};

var AdditionalHelpText = function AdditionalHelpText() {
  var communityUrl = (0, _globals.default)('communityUrl');
  return (0, _preact.h)("span", null, "View Intercom content in the", ' ', (0, _preact.h)("a", {
    className: "overview-page-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(encodeURI("".concat(communityUrl, "/search?source[0]=intercom"))),
    rel: "noreferrer",
    target: "_blank"
  }, "search result"), ' ', "on the community destination.", ' ');
};

var _default = IntegrationTab;
exports.default = _default;